import { graphql } from "@/gql";

export const updateIncidentMutation = graphql(`
  mutation UpdateIncident($id: ID!, $input: UpdateIncidentInput!) {
    updateIncident(id: $id, input: $input) {
      id
    }
  }
`);
